module.exports = __webpack_public_path__ + "static/media/tBaldwin.7db142c7.jpeg";